module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2362168"
    }
  }, [_c('b', [_vm._v("VIETNAMESE NOODLE SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2362668"
    }
  }, [_c('b', [_c('i', [_vm._v("Although Vietnamese soup is traditionally served with thinly sliced beef, our variation uses chicken breast meat. The flat, wide rice noodles ")]), _vm._v(" (bahn pho) "), _c('i', [_vm._v("can be purchased in the Asian section of some grocery stores or in Asian markets.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2365468"
    }
  }, [_c('b', [_vm._v("Prep: 20 minutes Cook: 25 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2365968"
    }
  }, [_vm._v("4 ounces flat dried rice noodles or linguine")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2366268"
    }
  }, [_vm._v("3 green onions, thinly sliced on diagonal")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2366568"
    }
  }, [_vm._v("2 garlic cloves, peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2366868"
    }
  }, [_vm._v("6 basil sprigs")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2367168"
    }
  }, [_vm._v("6 sprigs plus 2 tablespoons chopped fresh cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2367468"
    }
  }, [_vm._v("4 cans (14½ ounces each) low-sodium chicken broth "), _c('br'), _vm._v(" or 7 cups Chicken Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2369268"
    }
  }, [_vm._v("1 teaspoon coriander seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2369568"
    }
  }, [_vm._v("1 cinnamon stick (3 inches)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2369968"
    }
  }, [_vm._v("2 large skinless, boneless chicken breast halves "), _c('br'), _vm._v(" (1 pound)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2370568"
    }
  }, [_vm._v("4 medium mushrooms, trimmed and sliced "), _c('br'), _vm._v(" mint sprigs "), _c('br'), _vm._v(" lime wedges (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2371968"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In large bowl, soak rice noodles in enough "), _c('i', [_vm._v("warm water to cover ")]), _vm._v("20 minutes, or cook linguine as label directs. Drain.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2373768"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Meanwhile, in 3-quart saucepan, combine one-third of green onions, garlic, basil and cilantro sprigs, broth, coriander seeds, and cinnamon stick; heat to boiling over high heat. Reduce heat; cover and simmer 10 minutes. Strain through sieve set over bowl; discard solids. Return broth to saucepan.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2376268"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Cut chicken breast halves on diagonal into thin strips. Stir chicken, drained noodles, mushrooms, and remaining green onions into broth; heat to boiling over high heat. Reduce heat; cover and simmer until chicken loses its pink color throughout, about 3 minutes. Sprinkle with chopped cilantro and top with mint sprigs. Serve with lime wedges, if you like. Makes about 9 cups or 4 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2379668"
    }
  }, [_vm._v("Each serving: About 269 calories, 30g protein, 27g carbohydrate, 2g total fat (0g saturated), 66mg cholesterol, 1,107mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc181e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c71_r1.vue
// module id = 279
// module chunks = 0